// The SaaS-style Blocks|Table switch each First Mile section carries in its header. Per-section on
// purpose: ops often want the GRN board as cards while reading the picklist as a table.
import { AppstoreOutlined, TableOutlined } from "@ant-design/icons";
import { Segmented } from "antd";
import React from "react";

export type ViewMode = "blocks" | "table";

interface Props {
  value: ViewMode;
  onChange: (v: ViewMode) => void;
}

const SectionViewToggle: React.FC<Props> = ({ value, onChange }) => (
  <Segmented
    size="small"
    value={value}
    onChange={(v) => onChange(v as ViewMode)}
    options={[
      { value: "blocks", label: <span><AppstoreOutlined /> Blocks</span> },
      { value: "table", label: <span><TableOutlined /> Table</span> },
    ]}
  />
);

export default SectionViewToggle;
